import React from 'react';
import Folder from '../Folder/Folder';
import File from '../File/File';
import styles from './FileTree.module.scss';
import { FileNode } from '../../../../DataRoom';
import { convertEpochToDate } from '../../../../../../utils/utils';

interface FileTreeProps {
    data: FileNode[];
    index: number;
    masterFolderName?: string;
    fetchFiles: Function;
    setShowDataRoomModal: (value: { showModal: boolean; docId?: number; currentDocType?: string }) => void;
    selectedItems?: Set<string>;
    onItemSelect?: (itemId: string) => void;
    showCheckboxes?: boolean;
    isFolderFullySelected?: (folderId: string) => boolean;
    // isRecurCompany: boolean;
}

const FileTree: React.FC<FileTreeProps> = ({
    data,
    index,
    masterFolderName,
    fetchFiles,
    setShowDataRoomModal,
    selectedItems = new Set(),
    onItemSelect,
    showCheckboxes = false,
    isFolderFullySelected,
    // isRecurCompany,
}) => {
    return (
        <div className={styles.fileTree}>
            {data.map((item) =>
                item.type === 'folder' ? (
                    <Folder
                        // isRecurCompany={isRecurCompany}
                        fetchFiles={fetchFiles}
                        index={index + 1}
                        key={item.name}
                        name={item.name}
                        innerFiles={item.innerFiles ?? []}
                        lastUpdated={item.updatedAt ? convertEpochToDate(item.updatedAt) : '-'}
                        parentFolderName={masterFolderName ?? ''}
                        setShowDataRoomModal={setShowDataRoomModal}
                        isNew={item.isNew}
                        selectedItems={selectedItems}
                        onItemSelect={onItemSelect}
                        showCheckboxes={showCheckboxes}
                        isFolderFullySelected={isFolderFullySelected}
                    />
                ) : (
                    <File
                        // isRecurCompany={isRecurCompany}
                        fetchFiles={fetchFiles}
                        masterFolderName={masterFolderName ?? ''}
                        docId={item.docId ?? null}
                        index={index + 1}
                        key={item.name}
                        name={item.name}
                        lastUpdated={item.updatedAt ? convertEpochToDate(item.updatedAt) : '-'}
                        setShowDataRoomModal={setShowDataRoomModal}
                        isNew={item.isNew}
                        startDate={item?.metaData?.fileMetaData?.startDate || ''}
                        endDate={item?.metaData?.fileMetaData?.endDate || ''}
                        selectedItems={selectedItems}
                        onItemSelect={onItemSelect}
                        showCheckboxes={showCheckboxes}
                    />
                ),
            )}
        </div>
    );
};

export default FileTree;
